import React, { useEffect, useState } from "react";
import { format, isValid } from "date-fns";
import { ka } from "date-fns/locale";
import { nanoid } from "nanoid";
import { Link } from "react-router-dom";

import { useGetMainBlog } from "../../apiHooks/home";
import Image from "../imageComponent";
import LoaderCircle from "../loader";
import { ContainerBlock } from "../../styles";

import { BlogsHero } from "./styled";

const MainBlogHero: React.FC = () => {
  const locales = { ka };

  const { data, isLoading } = useGetMainBlog();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!isLoading && !data) return setHidden(true);
    return setHidden(false);
  }, [isLoading]);

  return (
    <>
      <BlogsHero style={{ display: `${hidden ? "none" : ""}` }}>
        <ContainerBlock big>
          {isLoading ? (
            <div className="loader">
              <LoaderCircle />
            </div>
          ) : data?.data?.results?.length ? (
            <div className="flex-wrap">
              <Link
                to={`/details/${data.data?.results[0].slug}`}
                className="image"
              >
                <Image
                  src={data?.data?.results[0]?.main_image}
                  layout="fill"
                  objectFit="cover"
                />
              </Link>

              <div className="main">
                <div className="category">
                  {data?.data?.results[0].category.map((el) => (
                    <Link key={nanoid()} to={`?category=${el.slug || el.name}`}>
                      {el.name}
                    </Link>
                  ))}
                </div>

                <h1 className="title">
                  <Link to={`/details/${data.data?.results[0].slug}`}>
                    {data.data?.results[0]?.title}
                  </Link>
                </h1>
                <p>{data.data?.results[0]?.preview}</p>
                <div className="date">
                  {data.data?.results[0]?.minutes} წუთის წასაკითხი ·{" "}
                  {isValid(new Date(data.data?.results[0].date))
                    ? format(
                        new Date(data.data?.results[0].date),
                        "dd MMMM yyyy",
                        {
                          locale: locales.ka,
                        }
                      )
                    : data.data?.results[0]?.date}
                </div>
              </div>
            </div>
          ) : null}
        </ContainerBlock>
      </BlogsHero>
    </>
  );
};

export default MainBlogHero;
